import { render, staticRenderFns } from "./ToReleaseCollectionBox.vue?vue&type=template&id=7c0c13cf&scoped=true"
import script from "./ToReleaseCollectionBox.vue?vue&type=script&lang=js"
export * from "./ToReleaseCollectionBox.vue?vue&type=script&lang=js"
import style0 from "./ToReleaseCollectionBox.vue?vue&type=style&index=0&id=7c0c13cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c13cf",
  null
  
)

export default component.exports